<div class="card d-flex flex-column">
  <div class="header">
    <span class="header-title">{{ sale_action }} {{ sale_type }}</span>
    @if (missing_fields.length) {
    <div class="header-alert d-flex align-items-center" role="alert">
      <i class="fa-solid fa-circle-exclamation me-2"></i>
      <span class="header-alert-prefix">Please fill in:</span>
      <div class="header-alert-chips">
        @for (field of missing_fields; track field) {
        <span class="header-alert-chip">{{ field }}</span>
        }
      </div>
      <button type="button" class="header-alert-close ms-2" aria-label="Dismiss" (click)="missing_fields = []">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    }
    <button type="button" class="close-btn" (click)="closeForm()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <!--body-->
  <div class="scroll">
    <form [formGroup]="this.salesForm">
      <!-- Top Row-->
      <div class="row d-flex justify-content-between align-items-end mb-4">
        <div class="col-auto">
          <div class="form-controls-row">
            <!-- Customer Section -->
            <div class="form-control-group" style="min-width: 350px">
              <label class="form-label"><span class="text-danger">*</span> Customer:</label>
              <ng-select [items]="accountingService.customers" bindLabel="contact.display_name" bindValue="id"
                [multiple]="false" [closeOnSelect]="true" class="form-control joined-select" formControlName="customer"
                id="customer" [placeholder]="customer_placeholder"
                (change)="getCustomerInfo(); customerDynamicPlaceholder()" (clear)="clearCustomerFields()">
                <ng-template ng-option-tmp let-item="item">
                  <div [title]="item?.contact?.display_name || ''">
                    {{ item?.contact?.display_name }}
                    <span style="
                        font-size: smaller;
                        color: rgba(255, 255, 255, 0.4);
                      ">
                      {{
                      item?.contact?.phone_number
                      ? formatPhoneNumber(item.contact.phone_number)
                      : ""
                      }}
                      {{
                      item?.contact?.email ? " | " + item.contact.email : ""
                      }}
                    </span>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <!-- Button Between Selects -->
            <div class="button-between">
              @if (!this.salesForm.get("customer").value) {
              <button type="button" class="btn red-btn add-button" (click)="addNewCustomer()"
                tooltip="Add Customer">
                <i class="fa-solid fa-plus"></i>
              </button>
              }
              @if (this.salesForm.get("customer").value) {
              <button type="button" class="btn yellow-btn edit-button" (click)="editCustomer()"
                tooltip="Edit Customer">
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              }
            </div>

            <!-- Email Section -->
            <div class="form-control-group" style="min-width: 340px; margin-left: 20px">
              <label class="form-label">Email:</label>
              <input class="form-control" type="email" id="email" formControlName="email"
                placeholder="customer@example.com" />
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="text-end">
            <div class="form-label mb-1">Total Amount</div>
            <div style="font-weight: 500; font-size: 1.5rem; color: #00a8ff">
              ${{ total.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>

      <!-- Second Row-->
      <div class="row mb-4">
        <div class="col-3">
          <!-- Billing address -->
          <div class="form-group2 w-100">
            <label class="form-label" for="billing_address">Billing Address:</label>
            <textarea class="form-control w-100" id="billing_address" formControlName="billing_address"
              style="height: 125px; resize: none" placeholder="Enter billing address..."></textarea>
          </div>
        </div>
        <div class="col-3">
          <!-- Receipt Date -->
          <div class="form-group w-100">
            <label class="form-label"><span class="text-danger">*</span> Receipt Date:</label>
            <div class="position-relative">
              <input #date_acquired="bsDatepicker" type="text" class="form-control w-100" formControlName="receipt_date"
                id="payment_date" placeholder="__/__/__ __:__" [bsConfig]="bsConfig" [readOnly]="false" bsDatepicker />
              <i class="fa-solid fa-calendar icon_inside_input" (click)="date_acquired.show()"></i>
            </div>
          </div>
          <!-- Sales Rep -->
          <div class="form-group w-100">
            <label class="form-label"><span class="text-danger">*</span> Sales Rep:</label>
            <input class="form-control w-100" type="text" id="sales_rep" formControlName="sales_rep"
              placeholder="Enter sales rep name" />
          </div>
        </div>
        <div class="col-3">
          <!-- Payment Method -->
          <div class="form-group w-100">
            <label class="form-label"><span class="text-danger">*</span> Payment Method:</label>
            <ng-select [items]="payment_methods" [multiple]="false" [closeOnSelect]="true" class="form-control w-100"
              formControlName="payment_method" id="payment_method" [placeholder]="payment_method_placeholder"
              (change)="paymentMethodDynamicPlaceholder()"></ng-select>
          </div>
          <!-- Reference Number -->
          <div class="form-group w-100">
            <label class="form-label" for="reference_number">Reference Number:</label>
            <input class="form-control w-100" type="text" id="reference_number" formControlName="reference_number"
              placeholder="Enter reference #" />
          </div>
        </div>
        <div class="col-3 text-end">
          <div class="sales-reference-badge px-3 py-2 mb-2">
            {{ sale_type }} #{{ this.sale_receipt.sales_receipt_number || preview_receipt_number }}
          </div>
          <br />
          @if (
          this.sale_receipt.status === "Void" ||
          this.sale_receipt.status === "Paid"
          ) {
          <div style="font-weight: 500; font-size: 1.1rem; display: flex; align-items: center; justify-content: flex-end; gap: 8px;">
            Status:
            <span class="badge rounded-pill text-dark"
                  [ngStyle]="{
                    'background-color': sale_receipt.status === 'Paid' ? 'darkseagreen' : (sale_receipt.status === 'Void' ? '#ffc107' : '#ffffff'),
                    'font-size': '0.85rem',
                    'padding': '4px 12px'
                  }">
              {{ this.sale_receipt.status }}
            </span>
          </div>
          }
        </div>
      </div>

      <!-- Category and Item Tables-->
      <div class="mb-1 p-1 rounded" style="
          background: rgba(255, 255, 255, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.05);
        ">
        <ag-grid-angular id="category_list" style="width: 100%; display: inline-block" [domLayout]="domLayout"
          [theme]="theme" [columnDefs]="columnDefs" [gridOptions]="gridOptions" [rowData]="saleItemData" [animateRows]="true"
          [rowSelection]="rowSelection" [components]="components" [enableBrowserTooltips]="true"
          (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"></ag-grid-angular>
        <div class="d-flex gap-2 mt-2">
          <button type="button" class="btn grey-btn btn-sm px-4" (click)="AddSalesItemLineClick()">
            <i class="fa-solid fa-plus me-2"></i>Add Lines
          </button>
          <button type="button" class="btn red-btn btn-sm px-4" (click)="clearAllSaleItemsLinesClick()">
            <i class="fa-solid fa-trash-can me-2"></i>Clear all Lines
          </button>
          @if (sharedService.company_info?.accounting_options?.credit_card_processing_rate > 0) {
            <button type="button" class="btn blue-btn btn-sm px-4" (click)="addCreditCardProcessingFee()" [disabled]="hasCreditCardFee()">
              <i class="fa-solid fa-credit-card me-2"></i>Add {{ sharedService.company_info.accounting_options.credit_card_processing_rate }}% CC Fee
            </button>
          }
        </div>
      </div>

      <!-- message_on_receipt, Attachments and Total-->
      <div class="row align-items-start mt-1">
        <div class="col-8">
          <div class="d-flex gap-4">
            <div class="flex-grow-1">
              <label class="form-label">Message on Receipt:</label>
              <textarea class="form-control" type="text" id="message_on_receipt" formControlName="message_on_receipt"
                rows="4" style="height: 120px; resize: none" placeholder="Enter message here... Max 255 chars"
                maxlength="255"></textarea>
              <!-- <small [class.text-danger]="salesForm.get('message_on_receipt').value?.length >= 255" class="text-light d-block text-end">{{ salesForm.get('message_on_receipt').value?.length || 0 }} / 255</small> -->
            </div>
            <div class="flex-grow-1">
              <label class="form-label">Message on Statement:</label>
              <textarea class="form-control" type="text" id="message_on_statement"
                formControlName="message_on_statement" rows="4" style="height: 120px; resize: none"
                placeholder="Enter message here... Max 255 chars" maxlength="255"></textarea>
              <!-- <small [class.text-danger]="salesForm.get('message_on_statement').value?.length >= 255" class="text-muted d-block text-end">{{ salesForm.get('message_on_statement').value?.length || 0 }} / 255</small> -->
            </div>
          </div>

          <div class="mt-4">
            <label class="form-label">Attachments:</label>
            <ngx-dropzone (change)="addAttachment($event)" [maxFileSize]="20000000" [multiple]="true" accept=".pdf">
              <ngx-dropzone-label>
                <i class="fa-solid fa-cloud-arrow-up fs-2 mb-2" style="color: #00a8ff"></i>
                <br />
                <span style="color: #00a8ff; font-weight: 500">Add Attachments</span>
                <br />
                <span style="font-size: small; opacity: 0.6">Max file size 20MB</span>
              </ngx-dropzone-label>

              @for (file of attachments; track file) {
              <ngx-dropzone-preview [removable]="true" (removed)="removeAttachment(file)">
                <ngx-dropzone-label>{{ file.name }}</ngx-dropzone-label>
              </ngx-dropzone-preview>
              }
            </ngx-dropzone>
          </div>
        </div>

        <div class="col-4">
          <div class="p-4 rounded" style="
              background: rgba(0, 0, 0, 0.2);
              border: 1px solid rgba(255, 255, 255, 0.05);
              margin-top: 25px;
            ">
            <!-- Subtotal -->
            <div class="div d-flex justify-content-between">
              <span>Subtotal:</span>
              <span>${{ subtotal.toFixed(2) }}</span>
            </div>
            <!-- Taxable Subtotal -->
            <div class="div d-flex justify-content-between">
              <span>Taxable Subtotal:</span>
              <span>${{ taxable_subtotal.toFixed(2) }}</span>
            </div>
            <!-- Sales Tax -->
            <div class="div d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-2">
                <label class="form-label mb-0 me-1" style="white-space: nowrap;"><span class="text-danger"
                    style="margin-right:5px">*</span>Sales Tax:</label>
                <ng-select [items]="sales_tax_options" bindLabel="name" bindValue="combined_rate" [multiple]="false"
                  [closeOnSelect]="true" class="form-control small-select" formControlName="sales_tax_option"
                  id="sales_tax_option" style="width: 150px" (change)="calculateTotals()"></ng-select>
                <span class="sales-tax-rate-badge" style="font-size: 1rem;">{{
                  this.salesForm.get("sales_tax_option").value * 100
                  }}%</span>
              </div>
              <span>${{ this.sales_tax_total }}</span>
            </div>

            <hr style="border-color: rgba(255, 255, 255, 0.1)" />

            <!-- Total -->
            <div class="div d-flex justify-content-between py-2" style="font-size: 1.25rem">
              <span style="color: #ffffff; font-weight: 500">Total:</span>
              <span style="color: #00a8ff; font-weight: 500">${{ total.toFixed(2) }}</span>
            </div>
            <!-- Amount Received -->
            <div class="div d-flex justify-content-between opacity-75">
              <span>Amount Received:</span>
              <span>${{ total.toFixed(2) }}</span>
            </div>
            <!-- Balance Due -->
            <div class="div d-flex justify-content-between opacity-75">
              <span>Balance Due:</span>
              <span>${{ total - total }}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- footer buttons -->
  <div class="footer">
    <button type="button" class="btn btn-sm grey-btn px-4" (click)="closeForm()">
      Cancel
    </button>

    <div class="d-flex gap-3">
      <div class="btn-group" dropdown container="body" [dropup]="isDropup">
        <button id="button-dropup" dropdownToggle type="button"
          class="btn btn-sm grey-btn dropdown-toggle px-4 text-nowrap" aria-controls="dropdown-dropup">
          Form Options
        </button>
        <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu dropdown-menu-dark" role="menu"
          aria-labelledby="button-dropup">
          <button class="dropdown-item py-2" [disabled]="!this.salesForm.valid || this.sale_action !== 'Edit'"
            (click)="printReceipt()">
            <i class="fa-solid fa-print me-2"></i>Print Receipt
          </button>
          <button class="dropdown-item py-2" [disabled]="
              !this.salesForm.valid ||
              this.sale_action !== 'Edit' ||
              !this.salesForm.controls['email'].value
            " (click)="emailReceiptClick()">
            <i class="fa-solid fa-envelope me-2"></i>Email Receipt
          </button>
          <button class="dropdown-item py-2 text-warning"
            [disabled]="!this.salesForm.valid || this.sale_action !== 'Edit'" (click)="voidReceiptClick()">
            <i class="fa-solid fa-ban me-2"></i>Void Receipt
          </button>
          <button class="dropdown-item py-2 text-danger"
            [disabled]="!this.salesForm.valid || this.sale_action !== 'Edit'" (click)="deleteReceiptClick()">
            <i class="fa-solid fa-trash me-2"></i>Delete Receipt
          </button>
        </ul>
      </div>

      <button type="button" class="btn btn-sm green-btn px-4"
        [class.disabled]="!this.salesForm.valid || !hasProductServiceProperty()" (click)="attemptSave(false)">
        Save
      </button>

      <button type="button" class="btn btn-sm green-btn px-5"
        [class.disabled]="!this.salesForm.valid || !hasProductServiceProperty()" (click)="attemptSave(true)">
        Save and Close
      </button>
    </div>
  </div>
</div>